import { Armor, ItemRarity } from 'game/core'
import { ItemUI } from 'game/extended/uis/item_uis'

import image from './hunters_vest.png'

export const hunters_vest: ItemUI<Armor> = {
    image,
    label: 'Hunters vest',
    value: 50,
    item: {
        key: 'hunters_vest',
        type: 'armor',
        rarity: ItemRarity.Rare,
        stats: {
            agility: 40,
            strength: 20,
            health: 20
        }
    }
}
